import type { MutationState } from "@tanstack/react-query";
import { useMutationState } from "@tanstack/react-query";

import { signalsQueryKeys } from "app/pages/sales-intelligence/sub-modules/signals/query/key-factory";

import type { IPermanentSignal } from "../../models/core/Signal";
import type SignalFilters from "../../models/core/SignalFilters";

export function useSaveDraftSignalMutationState<F extends SignalFilters = SignalFilters>(
    keyIdentifier?: string,
): MutationState<IPermanentSignal<F>> | undefined {
    const saveDraftSignalMutationState = useMutationState<MutationState<IPermanentSignal<F>>>({
        filters: { mutationKey: signalsQueryKeys.lifecycleTransition(keyIdentifier) },
    });

    return saveDraftSignalMutationState[saveDraftSignalMutationState.length - 1];
}
